module.exports = __webpack_public_path__ + "static/img/09.4134f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/09.jpg
// module id = VdDQ
// module chunks = 0